import React from "react";

const TermsConditions = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-6 text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold mb-6 text-black">
        Terms & Conditions
      </h1>

      <p className="mb-6">
        Last updated: <strong>31 jan 2026</strong>
      </p>

      <p className="mb-6">
        These Terms & Conditions govern your use of our website, products, and
        services. By accessing our website or placing an order, you agree to be
        bound by these Terms & Conditions.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        1. Use of Website
      </h2>
      <p>
        You agree to use this website for lawful purposes only. You must not
        misuse the website, attempt unauthorized access, or interfere with its
        operation.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        2. Product & Service Information
      </h2>
      <p>
        We make reasonable efforts to ensure that product descriptions, pricing,
        and availability are accurate. However, errors may occur, and we reserve
        the right to correct any inaccuracies without prior notice.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        3. Orders & Payments
      </h2>
      <p>
        Orders are confirmed only after successful payment through authorized
        payment gateways. We reserve the right to cancel or refuse any order in
        cases of payment failure, suspected fraud, or incorrect pricing.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        4. Pricing & Charges
      </h2>
      <p>
        All prices are displayed in Indian Rupees (INR). Prices may include or
        exclude delivery charges as communicated at the time of order
        confirmation.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        5. Shipping & Delivery
      </h2>
      <p>
        Shipping and delivery are governed by our Shipping Policy. Delivery
        timelines are estimates and may vary due to operational or external
        factors.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        6. Cancellations & Refunds
      </h2>
      <p>
        Cancellations and refunds are handled strictly in accordance with our
        Refund Policy. Please review the policy carefully before placing an
        order.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        7. Communication & Consent
      </h2>
      <p>
        By providing your contact details, you consent to receive communication
        from us via phone calls, SMS, WhatsApp, or Google RCS for service-related
        purposes such as order updates and support.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        8. Limitation of Liability
      </h2>
      <p>
        We shall not be liable for any indirect, incidental, or consequential
        damages arising from the use of our website or services, except as
        required under applicable Indian laws.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        9. Force Majeure
      </h2>
      <p>
        We shall not be held responsible for failure or delay in performance due
        to events beyond our reasonable control, including natural disasters,
        strikes, or government restrictions.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        10. Intellectual Property
      </h2>
      <p>
        All content on this website, including text, images, and logos, is the
        property of the business and may not be used without prior written
        permission.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        11. Governing Law
      </h2>
      <p>
        These Terms & Conditions are governed by and interpreted in accordance
        with the laws of India. Any disputes shall be subject to the exclusive
        jurisdiction of Indian courts.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        12. Changes to Terms
      </h2>
      <p>
        We reserve the right to modify these Terms & Conditions at any time.
        Changes will be effective upon posting on this page.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        13. Contact Information
      </h2>
      <p>
        For any questions regarding these Terms & Conditions, please contact us:
      </p>
      <p className="mt-2">
        <strong>Business Name:</strong> __________ <br />
        <strong>Phone:</strong> __________ <br />
        <strong>Email:</strong> __________
      </p>
    </div>
  );
};

export default TermsConditions;
